/* @flow */
import gql from 'graphql-tag';
import type {FilterGroupType} from '../components/MoreFilters/MoreFilters';

type FilteredCountQueryResults = {
    filterGroups?: FilterGroupType[],
    resultCount: number
};

export type FilteredCountQueryResponseData = {
    results: FilteredCountQueryResults,
    error?: Error,
    loading: boolean
};

export const fragments = {
    results: gql`
        fragment FilterCountsResults on Results {
            resultCount
            filterGroups {
                groupInfo {
                    name
                    id
                }
                filters {
                    count
                    checked
                    filter {
                        name
                        refineByQueryArgument
                        description
                    }
                }
            }
        }
    `
};

const filteredCountQuery = gql`
    query FilterCountQuery($params: ResultsParams) {
        results(params: $params) {
            id
            ...FilterCountsResults
        }
    }
    ${fragments.results}
`;

export default filteredCountQuery;
